module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAASdJREFUOE/t1L1Kw1AUwPH/aRtEXEToJPQFfAKxSArioKNfg9C0WHR0dlInZ0elYuLm16iDCM2g+AS+gOBUEBeREMqRNDRtKEgSXAre5cLlnN/9OPde4Y+bDHkVewaV1UTziN7Qqr0OxsbBOaeEoU/ALcjn76hOAiv4UubZeuvF9sHZ5hRjRoCd4FrHiVZoOrvADp5f5qXxEeSE4OLFBL4+AkXQs0RYFCRbQBtDFniofoVgxd4D2QC9T4dFG10CvaRVOwpB09nv9q51mAkcyB9p8CDHfMkkXzBix6AdD7fuxsYSbbl7jQo2kouDqIchm0FFIzQRmKY6/+BoXOwG6DbIXZri9mN1GeQU12qGT2/tKk/7uw5MZwN5pzh+zvV6Z/jHzij20n4AHPaFFTipXZIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person07.png
// module id = hJI1
// module chunks = 15